export default function Machines_D_2 (number = 1) {
  return {
    name: '制作台Mk.Ⅲ',
    icon: '/static/img/machines/d2.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_D/Machines_D_2.js